import { render, staticRenderFns } from "./state-to-done.vue?vue&type=template&id=c2252466&scoped=true"
import script from "./state-to-done.vue?vue&type=script&lang=js"
export * from "./state-to-done.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2252466",
  null
  
)

export default component.exports